import React from 'react';
import LandSearchGridItem from './LandSearchGridItem';

const LandSearchGrid = (props) => {
    return (
        <div className="land-search-grid">
            <div className="cf">
                {props.data.map((lot) =>
                    <LandSearchGridItem data={lot}  key={lot.id} />
                )}
            </div>
        </div>
    );
};

export default LandSearchGrid;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/LandSearchGrid.js
 **/